import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import React from "react";
import RegFont from "../RegFont";
import styles from "./styles.module.scss";
function PricingSummary(props) {
    return (_jsx(_Fragment, { children: _jsx("div", { className: [styles["upper-column"], styles["pricing-summary"]].join(" "), children: props.data.map((item) => (_jsxs("div", { className: styles["fully-spaced-row"], children: [_jsx(RegFont, { children: item.line_item_name }), item.line_item_name === "Discount" ? (_jsx(RegFont, { color: "#77B1AC", children: item.line_item_price })) : item.line_item_name === "This shipment" ? (_jsx(RegFont, { children: item.line_item_price })) : (_jsx(RegFont, { children: item.line_item_price }))] }, item.line_item_name))) }) }));
}
export default PricingSummary;
